import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBatchApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getBatchList = createAsyncThunk('getBatchList', async (payload) => {
  return await getBatchApi(payload);
});

const getBatchListSlice = createSlice({
  name: 'getBatchList', // Unique Name
  initialState,
  reducers: {
    getBatchListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchList.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getBatchList.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getBatchList.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getBatchListReset } = getBatchListSlice.actions;

export default getBatchListSlice.reducer;
